module.exports = __webpack_public_path__ + "assets/shape-rectangle.0ef1d65d.svg";